import GUAYAQUIL from ".././assets/bancos/guayaquil.png"
import numero from ".././assets/bancos/numero.png"
import pacifico from "../assets/bancos/pacifico.png"
import pichincha from "../assets/bancos/pichincha.png"
import produbanco from "../assets/bancos/produbanco.png"
import bancoguyaquil from "../assets/bancos/banco-guayaquil.png"
import bancopacifico from "../assets/bancos/banco-pacifico.png"
import produbancoguayaquil from "../assets/bancos/produbanco-guayaquil.png"
import diners from "../assets/bancos/diner-y mas.jpg"
import visas from "../assets/bancos/visa-maste.jpg"
import paypal from "../assets/bancos/paypal.jpg"
import vecino from "../assets/bancos/mi-vecino.png"
//import logo from "../assets/imagen/logo-t-ickets.png"
import cedericon from "../assets/imagen/iconoceder.png"
import atencion from "../assets/imagen/atencion.png"
export const bancos = {
    GUAYAQUIL, numero,
    pacifico, pichincha,
    produbanco,
     cedericon, atencion,
    diners, visas, paypal
}
export const bancosdetall = {
    bancoguyaquil,
    bancopacifico,
    produbancoguayaquil,
    vecino
}